import { StoryPeerInfo, StoryPeerType } from '@weblite/ts-action/story'
import { useCallback, useEffect, useState } from 'react'
import { useTheme } from '@mui/material'
import {
  useSelectedServerStoryRibbonIndex,
  useUploadingStoriesByPeerIdAndPeerType,
} from '$logic/story/react-hooks'
import { MobileSlider } from '$comp/_app/components/story/mobile-slider'
import { DesktopSlider } from '$comp/_app/components/story/desktop-slider'
import { useSetNativeColors } from '$logic/native-colors'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { StoryAnalyticsApi } from '$logic/story/analytics'
import { usePrevious } from '$common/react-hooks/use-previous'
import { closeStory } from '$logic/router'
import { BottomDrawer } from '$common/bottom-drawer'
import { SingleStory } from './single-story'
import { showCreateStoryModal } from '$comp/modals/create-story/create-story.api'
import { sortStoryRibbons } from '$logic/story/service'
import { nothing } from '$func/utils'

export interface Props extends StoryPeerInfo {
  isOpen?: boolean
  singleMode?: boolean
  xAxis: number
  yAxis: number
}

export function ViewStory({
  isOpen = false,
  peerType,
  peerId,
  singleMode,
}: Props) {
  const blackColor = useTheme().palette.neutral1000
  useSetNativeColors(
    () => ({
      statusBar: blackColor,
      bottomSafeArea: blackColor,
    }),
    [isOpen],
    isOpen,
  )

  const handleSwipeNext = useCallback(() => {
    StoryAnalyticsApi.swipe('NEXT', 'SWIPE')
  }, [])

  const handleSwipePrevious = useCallback(() => {
    StoryAnalyticsApi.swipe('PREVIOUS', 'TAP')
  }, [])

  const isStoryUploading = !!useUploadingStoriesByPeerIdAndPeerType(
    peerId,
    peerType,
  )

  const selectedRibbonStoryIndex = useSelectedServerStoryRibbonIndex(
    peerId,
    peerType,
  )

  const isDesktop = useIsDesktopSize()
  const prevSelectedRibbonStoryIndex = usePrevious(selectedRibbonStoryIndex)

  const handleClose = useCallback(() => {
    closeStory()
  }, [])

  const handleCreateStory = useCallback(
    async (peerId: string, peerType: StoryPeerType) => {
      await closeStory()

      setTimeout(() => {
        showCreateStoryModal({ peerId, peerType })
      }, 0)
    },
    [],
  )

  useEffect(() => {
    return () => {
      sortStoryRibbons()
    }
  }, [])

  if (
    prevSelectedRibbonStoryIndex === undefined &&
    selectedRibbonStoryIndex === -1 &&
    !isStoryUploading &&
    !singleMode
  ) {
    handleClose()
    return null
  }

  return (
    <BottomDrawer
      isTransparent
      isOpen={isOpen}
      isFullscreen
      onClose={nothing}
      sx={{ height: '100%' }}
      paperProps={{
        sx: { height: '100%', border: 'none' },
      }}
      fullWidth={isDesktop}
      backdropProps={{
        sx: isDesktop
          ? {
              backdropFilter: 'blur(2px)',
            }
          : undefined,
      }}
      variant="persistent"
    >
      {singleMode ? (
        <SingleStory
          onCreateStory={handleCreateStory}
          peerId={peerId}
          peerType={peerType}
          isOpen={isOpen}
          onClose={handleClose}
        />
      ) : isDesktop ? (
        <DesktopSlider
          onCreateStory={handleCreateStory}
          onClose={handleClose}
          peerId={peerId}
          peerType={peerType}
          isOpen={isOpen}
          onSwipeNext={handleSwipeNext}
          onSwipePrevious={handleSwipePrevious}
        />
      ) : (
        <MobileSlider
          onCreateStory={handleCreateStory}
          onClose={handleClose}
          peerId={peerId}
          peerType={peerType}
          isOpen={isOpen}
          onSwipeNext={handleSwipeNext}
          onSwipePrevious={handleSwipePrevious}
        />
      )}
    </BottomDrawer>
  )
}

// const Container = styled('div')<{ isDesktop: boolean }>`
//   display: flex;
//   border-radius: ${({ isDesktop }) => (isDesktop ? 0 : '200px')};
//   transition: all;
//   //width: 100%;
//   //height: 100%;
//   transition-duration: 200ms;
//   transition-timing-function: linear;
//   overflow: hidden;
// `

// useEffect(() => {
//   if (!containerRef.current) return
//
//   containerRef.current.style.position = 'absolute'
//   containerRef.current.style.opacity = delayedIsOpen ? '1' : '0'
//   containerRef.current.style.borderRadius = delayedIsOpen ? '0' : '200px'
//   containerRef.current.style.left = delayedIsOpen ? '0' : `${xAxis}px`
//   containerRef.current.style.width = delayedIsOpen ? '100%' : '48px'
//   containerRef.current.style.height = delayedIsOpen ? '100%' : '48px'
//   containerRef.current.style.top = delayedIsOpen ? '0' : `${yAxis}px`
// }, [delayedIsOpen, isOpen, xAxis, yAxis])

// <Contaienr
//   ref={containerRef}
//   isDesktop={isDesktop}
// >
